import { render } from "./Privacy.vue?vue&type=template&id=0cc8c1b5&scoped=true"
const script = {}

import "./Privacy.vue?vue&type=style&index=0&id=0cc8c1b5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0cc8c1b5"

export default script